import { useQuery } from "@tanstack/react-query";
import { useEffect, useCallback } from "react";

const useCameraCheck = () => {
	const query = useQuery({
		queryKey: ["camera"],
		queryFn: async () => {
			try {
				await navigator.mediaDevices.getUserMedia({ video: true });
				return true;
			} catch (error) {
				return false;
			}
		},
		enabled: false,
		staleTime: Infinity,
		retry: 0,
	});

	const checkCamera = useCallback(async () => {
		query.refetch();
	}, [query]);

	useEffect(() => {
		checkCamera();
	}, [checkCamera]);

	return {
		...query,
		checkCamera,
	};
};

export default useCameraCheck;
